import { ShowErrorPopup } from "../core/src/commands/GameCommands";
import { State } from "../core/src/states/State";
import ViewManager from "../core/src/utils/ViewManager";

export default class ErrorState extends State {
    public enter(): void {
        super.enter();
        ViewManager.getLayer("SplashOverlay").setScene("open");
        ShowErrorPopup(() => {
            //if (errorModel.critical) {
            location.reload();
            //} else {
            //this.exit();
            //}
        });
    }
}
